module.exports = __webpack_public_path__ + "img/all.000fe686.svg";